// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607230710/js/" + chunkId + "." + {"44":"91fba8f2","225":"537b95f9","481":"d95d2f31","486":"0444589c","770":"968c2cb9"}[chunkId] + ".0.28886667157021106.chunk.js";
};